
import components from '@/components'
import { compileStyles } from '@/modules/compileStyles'
export default {
  name: 'Testimonial',
  components,
  props: {
    blok: {
      required: true,
      type: Object
    }
  },
  computed: {
    style() {
      return compileStyles(this.blok.style || {}, this.$vuetify.breakpoint.name)
    }
  }
}
